import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { getDisplayName } from '../../../../../models/NameUtils';
import { ComboboxContent, ComboboxInput, ComboboxList } from '../../../../components-v2/Combobox';
import { UserCombobox, UserComboboxAvatarItem, UserComboboxStatus } from '../../../UserCombobox';
import { styleSheet } from './styles';

export const MeetingHostFilterDropdown = ({
	selectedHost,
	setSelectedHost,
	anchorClassName,
	readOnly = false,
}: {
	selectedHost: Api.IUser | null;
	setSelectedHost: React.Dispatch<React.SetStateAction<Api.IUser | null>>;
	anchorClassName?: string;
	readOnly?: boolean;
}) => {
	const id = React.useId();

	return (
		<div className={`${anchorClassName ?? ''}${readOnly ? ` ${css(styleSheet.disabledWrapper)}` : ''}`}>
			<UserCombobox id={selectedHost?.id} key={selectedHost?.id} onValueChange={setSelectedHost}>
				<ComboboxInput
					id={`${id}-host-combobox`}
					placeholder={selectedHost ? getDisplayName(selectedHost) : 'Host'}
					showClear={!!selectedHost}
					styles={[styleSheet.comboboxInput]}
					disabled={readOnly}
				/>
				<ComboboxContent styles={[styleSheet.comboboxContent]}>
					<UserComboboxStatus />
					<ComboboxList>{(user: Api.IUser) => <UserComboboxAvatarItem key={user.id} user={user} />}</ComboboxList>
				</ComboboxContent>
			</UserCombobox>
		</div>
	);
};
